import React from 'react';
import { Footer, SectionHeader } from '../../components'
import MainLayout from '../../layouts/main-layout/main-layout';

function redirectToAppStores() {
  let mobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    any: function () {
      return mobile.Android() || mobile.iOS();
    },
  };

  let client = mobile.any();

  if (String(client) === "Android") {
    const param = window.location.search.substring(1);
    window.location.replace(
      "https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay&" +
      param
    );
  } else if (
    String(client) === "iPhone" ||
    String(client) === "iPad" ||
    String(client) === "iPod"
  ) {
    setTimeout(() => {
      window.location.href =
        "https://apps.apple.com/mx/app/claro-pay/id1502765283";
    }, 1);
  } else {
    window.location.href = "https://mx.claropay.com/" + window.location.search;
  }

  return (
    <>
      <MainLayout />
      <SectionHeader />
      <Footer />
    </>
  )

}

export default redirectToAppStores;
